import React, { FC, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import NotificationAlert from "react-notification-alert";

import {
  get_markets_rates,
  get_markets_ohlcs,
  get_markets_ohlc,
  get_markets_orders,
  get_wallets,
  post_markets_exchanges,
} from "stores/Service/actions";
import moment from "moment/moment";

import ExchSimpleView from "./ExchAdvancedView";

import LoadingView from "../../modules/Loading/LoadingView";
import { getMessage } from "config/util";

const App = ({ nonce }) => {
  const dispatch = useDispatch();
  const ref = useRef();

  const toast = (error) => {
    const message = getMessage(error);
    dispatch_danger(message);
  };

  const dispatch_info = (message) => {
    if (ref.current) {
      var options = {};
      options = {
        place: "tc",
        message: (
          <div>
            <span data-notify="icon" className="nc-icon nc-bell-55" />
            <span>{message}</span>
          </div>
        ),
        type: "info",
        icon: "now-ui-icons ui-1_bell-53",
        autoDismiss: 5,
      };
      ref.current.notificationAlert(options);
    }
  };

  const dispatch_danger = (message) => {
    if (ref.current) {
      var options = {};
      options = {
        place: "tc",
        message: (
          <div>
            <span data-notify="icon" className="nc-icon nc-single-copy-04" />
            <span>{message}</span>
          </div>
        ),
        type: "danger",
        icon: "now-ui-icons ui-1_bell-53",
        autoDismiss: 5,
      };
      ref.current.notificationAlert(options);
    }
  };

  const dispatch_get_markets_rates = (data, page) => {
    dispatch(
      get_markets_rates({
        data,
        toast,
        page,
      })
    );
  };

  const dispatch_get_markets_ohlcs = (data, page) => {
    var unix_zone =
      moment.utc("1988-04-12 00:00").unix() - moment("1988-04-12 00:00").unix();

    var unix_minute = data.type * 60;
    var unix_today = moment()
      .startOf("day")
      .unix();

    var unix_delta = moment().unix() - unix_today;
    var unix_count = (unix_delta / unix_minute) | 0;

    var unix_first = unix_today + (unix_count + 1 - data.limit) * unix_minute;
    var unix_last = unix_today + (unix_count + 1) * unix_minute;
    var unix_lastest = unix_today + unix_count * unix_minute;

    dispatch(
      get_markets_ohlcs({
        data: { ...data, unix_first, unix_last, unix_zone, unix_minute },
        toast,
        page,
      })
    );
  };

  const dispatch_get_markets_ohlc = (data, page) => {
    var unix_zone =
      moment.utc("1988-04-12 00:00").unix() - moment("1988-04-12 00:00").unix();

    var unix_minute = data.type * 60;
    var unix_today = moment()
      .startOf("day")
      .unix();

    var unix_delta = moment().unix() - unix_today;
    var unix_count = (unix_delta / unix_minute) | 0;

    var unix_first = unix_today + (unix_count + 1 - data.limit) * unix_minute;
    var unix_last = unix_today + (unix_count + 1) * unix_minute;
    var unix_lastest = unix_today + unix_count * unix_minute;

    dispatch(
      get_markets_ohlc({
        data: { ...data, unix_first: unix_lastest, unix_last, unix_zone },
        toast,
        page,
      })
    );
  };
  const dispatch_get_markets_orders = (data, page) => {
    dispatch(
      get_markets_orders({
        data,
        toast,
        page,
      })
    );
  };

  const dispatch_get_wallets = (data, page) => {
    dispatch(
      get_wallets({
        data,
        toast,
        page,
      })
    );
  };

  const dispatch_post_markets_exchanges = (data, page) => {
    dispatch(
      post_markets_exchanges({
        data,
        toast,
        page,
      })
    );
  };

  useEffect(() => {
    dispatch_get_markets_rates({}, () => {});

    dispatch_get_wallets({}, () => {});
    // window.jQuery(".navbar-toggler").click();
  }, [nonce]);

  const reduce_get_markets_rates = useSelector(
    (state) => state.reduce_get_markets_rates
  );
  const reduce_get_markets_ohlcs = useSelector(
    (state) => state.reduce_get_markets_ohlcs
  );

  const reduce_get_wallets = useSelector((state) => state.reduce_get_wallets);
  const reduce_get_maps = useSelector((state) => state.reduce_get_maps);
  const reduce_get_accounts = useSelector((state) => state.reduce_get_accounts);

  // if (
  //   reduce_get_maps.isLoading ||
  //   reduce_get_accounts.isLoading ||
  //   reduce_get_markets_rates.isLoading ||
  //   // reduce_get_markets_ohlcs.isLoading ||
  //   reduce_get_wallets.isLoading
  // ) {
  //   return <LoadingView />;
  // }

  return (
    <>
      <div className="notification-container">
        <NotificationAlert ref={ref} />
      </div>

      <ExchSimpleView
        loading={reduce_get_markets_ohlcs.isLoading_ohlcs}
        maps={reduce_get_maps}
        accounts={reduce_get_accounts}
        rates={reduce_get_markets_rates.rates}
        rates_jpy={
          reduce_get_markets_rates.rates_jpy
            ? reduce_get_markets_rates.rates_jpy
            : {}
        }
        scc={reduce_get_markets_rates.scc}
        ohlcs={reduce_get_markets_ohlcs.ohlcs}
        wallets={reduce_get_wallets.wallets}
        dispatch_info={dispatch_info}
        dispatch_danger={dispatch_danger}
        dispatch_get_markets_rates={dispatch_get_markets_rates}
        dispatch_get_markets_ohlcs={dispatch_get_markets_ohlcs}
        dispatch_get_markets_ohlc={dispatch_get_markets_ohlc}
        dispatch_get_markets_orders={dispatch_get_markets_orders}
        dispatch_get_wallets={dispatch_get_wallets}
        dispatch_post_markets_exchanges={dispatch_post_markets_exchanges}
      />
    </>
  );
};

export default App;
